import { render } from "./NearbyTrailerResultsList.vue?vue&type=template&id=b0535ee8&scoped=true&ts=true"
import script from "./NearbyTrailerResultsList.vue?vue&type=script&lang=ts"
export * from "./NearbyTrailerResultsList.vue?vue&type=script&lang=ts"

import "./NearbyTrailerResultsList.vue?vue&type=style&index=0&id=b0535ee8&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0535ee8"]])

export default __exports__